import React from 'react'

export default function Portfolio() {
  return (
    <div className="items-center justify-items-center bg-gradient-to-b from-[#c8dbda] to-[#f1f3e9] bg-opacity-10 opacity-100 relative text-primary py-[5%] px-[5%]" id="portfolio">
      <h2 className="md:text-5xl text-3xl uppercase font-bold text-center font-capital my-6">Portfolio</h2>
      <div className="md:grid flex md:flex-none flex-col md:grid-cols-3 grid-cols-none md:gap-8 gap-2 items-center my-8">
        <div className="mx-auto md:col-span-2 relative overflow-hidden cursor-pointer block">
          <div className="absolute top-0 bg-[#bfc1b7] opacity-0 flex items-center justify-center h-full w-full hover:opacity-100 hover:bg-opacity-30">
            <a className='bg-white text-black font-medium px-4 py-3 rounded-full' href='https://impostor-game-web.netlify.app/'>Live Preview</a>
          </div>
          <img src="assets/images/impostor-web.png" alt="impostor-web" />
        </div>
        <div className='md:text-left text-center mx-auto md:mb-0 mb-10'>
          <p className='md:text-xl text-base font-bold my-3'>Impostor Game Web</p>
          <p className='font-medium'>An online game website to play some of the available games without having to download an application. Created with Next JS, Redux, Tailwind CSS, and several packages as media handling</p>
        </div>
      </div>
      
      <div className="md:grid flex md:flex-none flex-col-reverse md:grid-cols-3 grid-cols-none md:gap-8 gap-2 items-center">
        <div className='md:text-right text-center mx-auto md:mb-0 mb-10'>
          <p className='md:text-xl text-base font-bold my-3'>Visit Tegal Web (On Progress)</p>
          <p className='font-medium'>A website that aims to display tourism, the local events, and culture in Tegal City and around that. Created with Reac JS and Tailwind CSS</p>
        </div>
        <div className="mx-auto md:col-span-2 md:col-start-2 relative overflow-hidden cursor-pointer block">
          <div className="absolute top-0 bg-[#bfc1b7] opacity-0 flex items-center justify-center h-full w-full hover:opacity-100 hover:bg-opacity-30">
            <a className='bg-white text-black font-medium px-4 py-3 rounded-full' href='https://visit-tegalv2.netlify.app/'>Live Preview</a>
          </div>
          <img className="border border-[#C9C9C9]" src="assets/images/visit-tegal.png" alt="visit-tegal" />
        </div>
      </div>
    </div>
  )
}
